import type { ReactNode } from 'react';

export function DeckCompletionPanel({ title = 'Your reviewed deck is ready', description, children }: {
  title?: string; description: ReactNode; children: ReactNode;
}) {
  return <section className="rounded-3xl border border-border bg-white px-6 py-14 text-center shadow-sm">
    <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-emerald-50 text-2xl text-emerald-700">✓</div>
    <h2 className="font-serif text-3xl font-semibold">{title}</h2>
    <p className="mt-3 text-muted">{description}</p>
    {children}
  </section>;
}
